import { useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { SectionRailContext } from "./sectionRailContext.js";
import styles from "./sectionRail.module.scss";

// The release command-center's per-section ACTIONS (Ryan, ART-201; moved onto the tab row in ART-278). The
// strip already names the section, so there is no in-tab header: a section injects its buttons through this
// portal into the host `ReleaseDetailScreen` draws at the right end of the section tabs, and keeps its own
// body markup unchanged. Desktop-only surface (the builder never renders below `lg`, ART-153). A section
// offering no actions renders nothing — the read-only-seat case, and Budget, whose actions are inline.

export function SectionRail({ children }: { children: ReactNode }) {
  const host = useContext(SectionRailContext);
  if (children == null || children === false) return null;
  const content = <div className={styles.row}>{children}</div>;
  // In the command center the actions portal onto the tab row. Rendered WITHOUT that host — a section mounted
  // in isolation, e.g. a unit test or a future preview — fall back to inline so the actions are never
  // silently swallowed.
  return host ? createPortal(content, host) : content;
}
